import { Component, Input, OnInit } from '@angular/core';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { ModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'app-photo-capture-time',
  templateUrl: './photo-capture-time.component.html',
  styleUrls: ['./photo-capture-time.component.scss'],
})
export class PhotoCaptureTimeComponent extends BaseModal implements OnInit {
  @Input() timeArray: any;
  array: Array<{ hour: number, isTime: boolean }> = [];
  required: boolean = false;
  constructor(private modalService: ModalService) {
    super();
    super._modalService = modalService;
  }


  ionViewDidEnter() {
    if (this.timeArray) {
      this.timeArray = this.timeArray.split(",");
    } else {
      this.timeArray = [8, 20];
    }
    for (let index = 0; index < 24; index++) {
      if (this.timeArray.filter(e => { return e == index }).length > 0) {
        this.array.push({ hour: index, isTime: true });
      } else {
        this.array.push({ hour: index, isTime: false });
      }
    }
  }

  select() {
    let isValid = true;
    if (this.array.filter(e => e.isTime == true).length == 0) {
      isValid = false;
    }
    if (isValid) {
      let timeArray = [];
      this.array.filter(e => e.isTime == true).forEach(element => {
        timeArray.push(element.hour);
      });
      // timeArray.join(",")

    } else {
      this.required = true;
    }
  }

  chooseTime(i: number) {
    this.array[i].isTime = !this.array[i].isTime;
  }

  save() {
    let timeArray = [];
    this.array.filter(e => e.isTime == true).forEach(element => {
      timeArray.push(element.hour);
    });
    this.dismiss(timeArray.join(","), "update");
  }

  ngOnInit() { }

}
